import { injectable } from "inversify";
import { Area } from "Models/Areas/Area";
import { TemplateFilter } from "Models/Filters/TemplateFilter";
import { AuditTemplateFilterState } from "Store/AuditTemplates/AuditTemplateFilterState";
import { IAuditTemplateFilterFactory } from "./IAuditTemplateFilterFactory";

@injectable()
export class AuditTemplateFilterFactory implements IAuditTemplateFilterFactory {
    public create(filterState: AuditTemplateFilterState): TemplateFilter {
        return {
            skip: filterState.skip,
            take: filterState.take,
            query: filterState.query,

            areaIds: this.getAreaIds(filterState.area),
            roles: filterState.roles,
            instructionsAttached: filterState.instructionsAttached,
            photoAttached: filterState.photoAttached
        };
    }

    private getAreaIds(selectedArea?: Area): number[] | undefined {
        if (selectedArea) {
            const getAreaIdsOfArea = (area: Area): number[] => {
                const arr = [area.id];

                if (area.children) {
                    return arr.concat(...area.children.map(x => getAreaIdsOfArea(x)));
                }

                return arr;
            };

            return getAreaIdsOfArea(selectedArea);
        }
        return undefined;
    }
}


// WEBPACK FOOTER //
// ./src/Factories/Audits/AuditTemplateFilterFactory.ts